import { PayloadAction, createSlice, current } from "@reduxjs/toolkit";
import { GroupItem } from "../../types/groupItem";
import {
  SortingDataType,
  TableSortDirection,
  sortArrayBy,
} from "../../common/logic/TableSortUtils";
import {
  createGroupThunk,
  deleteGroupThunk,
  fetchGroupsThunk,
} from "../thunk/groupsThunk";
import { setInitalPagination } from "./utils";

export interface GroupsState {
  onSave: boolean;
  groupsData: GroupItem[] | [];
}

const initialState: GroupsState = {
  onSave: true,
  groupsData: [],
};

export const groupsSlice = createSlice({
  name: "groups",
  initialState,
  reducers: {
    setGroupsData: (state, action: PayloadAction<GroupItem[]>) => {
      state.groupsData = action.payload;
    },
    createGroup: (state, payload: PayloadAction<GroupItem>) => {
      state.groupsData = [payload.payload, ...state.groupsData];
    },
    deleteGroup: (state, payload: PayloadAction<number>) => {
      state.groupsData = state.groupsData.filter(
        (group) => group.id !== payload.payload
      );
    },
    sortGroupsTable: (
      state,
      payload: PayloadAction<{
        dataField: string;
        direction: TableSortDirection;
        dataType: SortingDataType;
      }>
    ) => {
      const { dataField, dataType, direction } = payload.payload;
      const arrayToSort = current(state.groupsData);
      state.groupsData = sortArrayBy(
        arrayToSort,
        dataField,
        dataType,
        direction
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGroupsThunk.fulfilled, (state, action) => {
      state.groupsData = (action.payload ?? []) as GroupItem[];
      setInitalPagination(state, action.payload as GroupItem[]);
    });
    builder.addCase(createGroupThunk.fulfilled, (state, action) => {});
    builder.addCase(deleteGroupThunk.fulfilled, (state, action) => {
      state.groupsData = state.groupsData.filter(
        (group) => group.id !== action.payload
      );
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  setGroupsData,
  createGroup,
  deleteGroup,
  sortGroupsTable,
} = groupsSlice.actions;

export default groupsSlice.reducer;
